import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { restPasswordConfirm } from "../api";

export default function ConfirmPassword() {
  const { uid, token } = useParams();
  const navigate = useNavigate()

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const rules = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    symbol: /[\W_]/.test(password), // includes !@#$%^&*()_+ etc.
  };

  const allRulesPassed = Object.values(rules).every(Boolean);
  const passwordsMatch = password === confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await restPasswordConfirm(password, uid, token);
      if (response.message) {
        alert(response.message);
        navigate("/login")
    }
      setError(null);
    } catch (err) {
      setMessage(null);
      setError(
        err.response?.data?.error || "Fehler beim Zurücksetzen des Passworts."
      );
    }
  };

  const RuleItem = ({ label, passed }) => (
    <li className={`flex items-center gap-2 ${passed ? "text-green-600" : "text-gray-500"}`}>
      {passed ? "✅" : "❌"} {label}
    </li>
  );

  return (
    <div className="max-w-md mx-auto mt-12 p-4 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4 text-center">🔑 Passwort zurücksetzen</h2>

      {message && <div className="text-green-600 mb-4">{message}</div>}
      {error && <div className="text-red-600 mb-4">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block font-medium mb-1">Neues Passwort</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <ul className="text-sm mb-4 space-y-1 pl-4">
          <RuleItem label="Mindestens 8 Zeichen" passed={rules.length} />
          <RuleItem label="Mindestens 1 Großbuchstabe" passed={rules.uppercase} />
          <RuleItem label="Mindestens 1 Kleinbuchstabe" passed={rules.lowercase} />
          <RuleItem label="Mindestens 1 Sonderzeichen" passed={rules.symbol} />
        </ul>

        <div className="mb-4">
          <label className="block font-medium mb-1">Passwort wiederholen</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {confirmPassword && (
            <p className={`text-sm mt-1 ${passwordsMatch ? "text-green-600" : "text-red-600"}`}>
              {passwordsMatch ? "✅ Passwörter stimmen überein" : "❌ Passwörter stimmen nicht überein"}
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={!allRulesPassed || !passwordsMatch}
          className={`w-full py-2 rounded ${
            allRulesPassed && passwordsMatch
              ? "bg-blue-600 text-white hover:bg-blue-700"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
          }`}
        >
          Passwort bestätigen
        </button>
      </form>
    </div>
  );
}
